const formatAmount = value => {
    if (value === undefined || value === null || value === '') return '—';
    return parseFloat(value).toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};

const toCent = value => {
    return Math.round(value * 100);
};

export { formatAmount, toCent };
